
  <mat-dialog-content class="boards-dialog setup">
    <div (click)="showPrevStep()" class="step-container assessment_mt-25  cursor-pointer" *ngIf="!data?.isBoardEdit">
      <img src="assets/img/back-arrow-icon-dark.svg" class="back"><div class="step">STEP 3/4</div>
    </div>
    
    <div class="heading">
      {{ data?.message }}
    </div>
    <div class="info-div">
      {{data?.message2}}
    </div>
    
    
      <input type="text" class="form-control search" placeholder="Search board name" (keyup)="searchBoards($event)">
      <div class="boards-box assessment_pt-20">
        <div class="board-box {{index === i ? 'selected': ''}}" *ngFor="let i of searchIndices" (click)="saveIndex(i)">
          
            <img class="icon-24 assessment_mr-8" [src]="boards[i]?.image" alt="">
            <div>
              <div class="board-name">
                {{boards[i]?.name}}
              </div>
              <div class="board-desc">
                {{boards[i]?.description}}
              </div>
          </div>
          
        </div>
      </div>

      <div class="m-bottom-btn d-flex justify-content-md-end assessment_mt-25" *ngIf="data?.isBoardEdit">
          <button type="button" class="btn btn-primary btn-save-details" (click)="onConfirmClick()">SAVE PREFERENCE</button>
          <button type="button" style="color: #0C9968;" class="ASM_no-box-shadow btn btn-link assessment_mb-0 assessment_pr-30 assessment_pl-30" (click)="onNoClick()">Cancel</button>
      </div>
    
    
          
  </mat-dialog-content>